const MSConnections = [
  'I have MS',
  'I might have MS',
  'I know someone with MS',
  'I work within the MS community',
  'Other',
];

export const MSConnections3rdPerson = [
  'Has MS',
  'Might have MS',
  'Knows someone with MS',
  'Works within the MS community',
  'Other',
];

export default MSConnections;
